<template>
    <div v-for="(nodes, idx) in chunkedNodes" :key="idx">
        <div class="row">
            <div class="col-12 p-2" v-for="node in nodes" :key="node.id">
                <div v-if="node.activeTitle" class="m-2 shadow rounded">
                    <div class="p-3">
                        <ContainerNode :contentTree="$root.contentTree" :node="node"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContainerNode from '../navigator/ContainerNode.vue';

export default {
    name: "StandardCodeView",
    components: {
        ContainerNode
    },
    props: {
        chunkedNodes: {
            type: Array,
            required: true
        }
    }
}
</script>